import {
	Output,
	EventEmitter,
	HostListener,
	ViewChild,
	ElementRef,
} from "@angular/core";
import { CourseContextModelService } from "./../../../models/course-context-model.service";
import { CourseStructureModelService } from "./../../../models/course-structure-model.service";
import {
	Component,
	OnInit,
	Input,
	SimpleChanges,
	ViewContainerRef,
} from "@angular/core";
import { UtilityScripts } from "../../../../helpers/utility-scripts";
import { AppServices } from "app/app.services";
import { ApplicationModel } from "app/core/models/application.model";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { CourseScene } from "app/core/vo/course-scene";
import { CoursePage } from "app/core/vo/course-page";
import { SceneStructure } from "app/core/vo/scene-structure";
import { DescriptorModelService } from "app/core/models/descriptor-model.service";
@Component({
	selector: "app-progress-card",
	templateUrl: "./app-progress-card.component.html",
	styleUrls: ["./app-progress-card.component.scss"],
})
export class AppProgressCardComponent implements OnInit {
	@ViewChild("progresscard", { static: true }) progresscard: ElementRef;
	@Input() progressVal: number;
	@Output() CloseEvent: EventEmitter<any> = new EventEmitter();
	public scenesArr: CourseScene[] = [];
	public selectedScene: SceneStructure;
	public currentPageInfo: CoursePage;
	public selectedSceneStyle: any;
	public pageColumns: any[];
	private pages_length: number = 15;
	constructor(
		private courseContextModelService: CourseContextModelService,
		private courseStructureModel: CourseStructureModelService,
		private descriptorService: DescriptorModelService
	) {}

	ngOnInit() {
		this.setupScenes();
	}

	ngOnChanges(simplechanges: SimpleChanges) {
		if (simplechanges && simplechanges.hasOwnProperty("progressVal")) {
			this.setupScenes();
		}
	}
	private setupScenes() {
		this.currentPageInfo = this.courseContextModelService.currentPageInfo;
		this.scenesArr = [];
		const moduleStructures: any =
			this.courseContextModelService.courseStructure.moduleStructures;
		const sceneStructures = moduleStructures.map((module) => {
			return module.childScenes.map((scenes) => scenes);
		});
		for (let item of sceneStructures) {
			this.scenesArr = this.scenesArr.concat(item);
			let deletedFound = JSON.stringify(item).indexOf('"deleted":true');
			if(deletedFound > -1){
				let deletePage = item[0].childPages.find(
					(page) => page.deleted
				);
				if (deletePage) {
					const intIndex = item[0].childPages.indexOf(deletePage);
					if(intIndex > -1){
						item[0].childPages.splice(intIndex, 1);
					}
				}
			}
		}
	}

	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}

	public get progresscardlabel() {
		return this.descriptorService.getDescriptorTextById("progress_label");
	}

	public sceneButtonClickhandler(event, scene: SceneStructure) {
		this.pageColumns = [];

		const childPages: any[] = [...scene.childPages];
		while (childPages.length > 0) {
			const column = childPages.splice(0, this.pages_length);
			this.pageColumns.push(column);
		}
		this.selectedScene = scene;
	}
	public sceneCloseButtonClickhandler(event) {
		this.selectedScene = null;
	}

	@HostListener("document:mousedown", ["$event"])
	onGlobalClick(event): void {
		if (
			event &&
			event.target &&
			event.target != this.progresscard &&
			!this.isDescendant(event.target, "progresscard") &&
			!this.isDescendant(event.target, "progressBtn")
		) {
			this.selectedScene = null;
			this.CloseEvent.emit({ closed: true });
		}
	}
	private isDescendant = (el, parentId) => {
		let isChild = false;
		if (el.id === parentId) {
			//is this the element itself?
			isChild = true;
		}
		while ((el = el.parentNode)) {
			if (el.id == parentId) {
				isChild = true;
			}
		}
		return isChild;
	};
}
